export interface Notification {
  type: string
  message: string
}

export function useNotification() {
  const notification = useState<Notification | null>('notification', () => undefined)
  const timeoutId = ref<number | null>(null)

  const show = (not: Notification) => {
    notification.value = not

    if (timeoutId.value !== null) {
      clearTimeout(timeoutId.value)
    }

    timeoutId.value = setTimeout(() => {
      close()
    }, 5000)
  }

  const close = () => {
    notification.value = undefined

    if (timeoutId.value !== null) {
      clearTimeout(timeoutId.value)
      timeoutId.value = null
    }
  }

  return {
    notification,
    show,
    close,
  }
}
